import { initSessionDuration } from 'application/session_duration'
import { pushEventToGTMDataLayer } from 'application/gtm_utils'
import 'application/feedback_widget'
import 'application/application'
import 'shared/flexible_header'
import 'application/ajax'
import 'application/bind_global_dom_events'
import 'application/recaptcha'
import 'application/messaging'
import 'application/overlay_plugin' // fancybox alternative
import 'application/popups'
import 'application/salesforce_chat'
import 'application/utils'

import 'shared/form_material_design'
import 'shared/go_to_top'
import 'shared/flash_message'
import 'shared/breadcrumbs_flexible'
import 'shared/smart_search'
import 'shared/pingator'
import 'shared/promotion_modal'
import 'application/soft_update'
import 'application/standard_tracking'
import 'application/tracking_link_and_toggle'
import 'application/tracking_form'
import { loginEvent } from '../application/ga_login_event'
import { studentExpired } from '../application/ga_student_expired'
import 'application/optimizely_tracking'
import 'application/optimizely_test_data'
import 'application/feedback_widget/injector.js'

SOPHIA.loginEvent = loginEvent
SOPHIA.studentExpired = studentExpired
SOPHIA.pushEventToGTMDataLayer = pushEventToGTMDataLayer

initSessionDuration()
